module.exports = __webpack_public_path__ + "img/A58A1064_min.bee148f5.jpg";